import styled from "styled-components";
import IconButton from "@mui/material/IconButton";
import { Tabs } from "antd";

export const SettingPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 20px);
  background: #fff;
  padding: 32px 20px 20px 32px;
  margin: 10px;
  border-radius: 8px;
  overflow: hidden;
  
  @media (max-width: 768px) {
    padding: 16px 12px 12px 16px;
    margin: 5px;
  }
`;

export const SettingPageHeader = styled.div`
  font-weight: 600;
  font-size: 24px;
  font-family: 'Manrope', sans-serif;
`;

export const NotifSection = styled.div`
  border: 1px solid #eaeaea;
  border-radius: 8px;
  overflow: hidden;
`;

export const NotifSectionHeader = styled.div`
  background-color: #f3f4f780;
  padding: 12px 16px;
  font-weight: 600;
  font-size: 16px;
  color: #1b2028;
  font-family: 'Manrope', sans-serif;
`;

export const NotifItemRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-top: 1px solid #f0f0f0;

  &:first-of-type {
    border-top: none;
  }
`;

export const NotifLabel = styled.span`
  font-size: 14px;
  color: #1b2028;
  font-weight: 500;
  font-family: 'Manrope', sans-serif;
`;

export const StyledSettingsTabs = styled(Tabs)`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: calc(100vh - 200px);

  .ant-tabs-nav::before {
    border: none !important; // remove the bottom border line
  }

  .ant-tabs-nav {
    margin: 0;
    flex-shrink: 0;
  }

  .ant-tabs-content-holder {
    padding-top: 20px;
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    min-height: 0;
  }

  .ant-tabs-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    min-height: 0;
  }

  /* ✅ Only active tab gets full height */
  .ant-tabs-tabpane-active {
    // flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow: hidden;
  }

  .ant-tabs-tab {
    flex: 0 0 auto;
    justify-content: center;
    text-align: center;
    padding: 12px 10px;
    font-weight: 400;
    font-size: 13px;
    color: #5a6c87;
    font-family: 'Manrope', sans-serif;

    &:hover {
      color: #0c53bb;
    }
  }

  .ant-tabs-tab-active .ant-tabs-tab-btn {
    font-weight: 600;
    color: #0c53bb !important;
  }

  .ant-tabs-tab:focus,
  .ant-tabs-tab:focus-visible {
    outline: none !important;
    box-shadow: none !important;
  }

  .ant-tabs-tab div {
    outline: none !important;
  }

  .ant-tabs-tab-active {
    .ant-tabs-tab-btn {
      font-weight: 600;
      color: #0c53bb !important;
    }
  }
`;

export const StyledSwitch = styled.div`
  .ant-switch {
    width: ${(props) => props.$width || "46px"};
    height: ${(props) => props.$height || "28px"};
    background-color: ${(props) => (props.checked ? "#1677ff" : "#DDE2E9")};
    padding: 0;
    transition: all 0.3s ease;

    &:hover {
      background-color: ${(props) => (props.checked ? "#1677ff" : "#cbd4e1")};
    }
  }

  .ant-switch-handle {
    width: ${(props) => props.$handleSize || "22px"};
    height: ${(props) => props.$handleSize || "22px"};
    top: 3px;
    left: 3px;

    &::before {
      border-radius: ${(props) => props.$handleRadius || "50%"};
    }
  }

  .ant-switch-checked .ant-switch-handle {
    left: calc(100% - ${(props) => props.$handleSize || "22px"} - 3px);
  }

  .ant-switch-checked {
    background-color: #0c53bb;
  }
`;

export const Container = styled.div`
  display: flex;
  min-width: 0;
  overflow-y: auto;
  overflow-x: hidden;
  align-items: flex-start;
  border: 1px solid #dde2e9;
  border-radius: 7px;
`;

export const ErrorPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
  color: #5a6c87;
`;

export const TemplateContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  width: 100%;
  border-radius: 0 8px 8px 0;
  flex: 1;
`;

export const Sidebar = styled.div`
  width: 260px;
  border-right: 1px solid #dde2e9;
  background: #fff;
  border-radius: 7px 0 0 0;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
`;

export const MainContent = styled.div`
  flex: 1;
  padding: 16px;
  overflow: auto;
`;

export const CategoryList = styled.div`
  list-style: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px 16px 20px 16px;
  button {
    height: 40px;
    padding: 10px;
    cursor: pointer;
    margin-bottom: 12px;
    font-size: 14px;
    font-family: 'Manrope', sans-serif;
    font-weight: 400;
    color: #5a6c87;
    background: transparent;
    border: none;
    outline: none;
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    &.active {
      font-weight: 600;
      color: #0c53bb;
      background: #f1f6fe;
      border-radius: 6px;
      border: 1px solid #c3d5f1;
    }
  }
  button .label {
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  button .count {
    flex-shrink: 0;
    margin-left: 8px;
  }
`;

export const CategoryHeader = styled.div`
  font-size: 14px;
  font-weight: 600;
  font-family: 'Manrope', sans-serif;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f3f4f750;
  border-bottom: 1px solid #dde2e9;
  padding: 10px 15px;
  font-weight: 600;
  font-family: 'Manrope', sans-serif;
  font-size: 16px;
  border-left: none;
  height: 55px;
`;

export const SectionTitle = styled.div`
  font-family: 'Manrope', sans-serif;
  font-size: 16px;
  font-weight: 500;
  color: #1b2028;
  margin: 16px 0;
`;

export const TemplatesGrid = styled.div`
  padding: 16px 16px 20px 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  .scroll-wrapper {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
  .section {
    min-height: 200px;
  }
`;

export const TemplateGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 16px;
`;

export const EmptyText = styled.div`
  display: flex;
  justify-content: center;
  color: #999;
  padding: 16px;
`;

export const TemplateCard = styled.div`
  display: flex;
  flex-direction: column;
  width: 150px;
  position: relative;
  overflow: visible;
  background: #fff;

  .preview {
    border-radius: 4px;
    width: 100%;
    height: 190px;
    object-fit: contain;
    background: #fff;
    border: 1px solid #dde2e9;
    box-shadow: 0 8px 18px rgba(15, 23, 42, 0.08);
  }

  .preview-placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    color: #999;
    font-size: 12px;
    font-family: Manrope, sans-serif;
  }

  .footer {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 6px;
    padding: 8px 0;
  }

  .template-name {
    font-size: 14px;
    font-weight: 500;
    line-height: 1.25;
    color: #111827;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .menu-icon {
    cursor: pointer;
    font-size: 16px;
    color: #9ca3af;
    transform: rotate(90deg);
    margin-top: 2px;
    padding: 2px;
    flex: 0 0 auto;
  }
`;

export const UploadButtonStyles = {
  backgroundColor: "#0C53BB",
  color: "#fff",
  textTransform: "none",
  padding: "6px 16px",
  borderRadius: "8px",
  display: "flex",
  alignItems: "center",
  gap: "0px",
  flexShrink: 0,
  width: "fit-content",
  fontFamily: "Manrope",
  fontSize: "13px",
  fontWeight: 600,
  "& .MuiButton-endIcon": {
    marginLeft: "4px",
  },
  "&:hover": {
    backgroundColor: "#0C53BB",
  },
  "&.Mui-disabled": {
    backgroundColor: "#e0e0e0",
    color: "#9e9e9e",
  },
  "&.MuiButton-endIcon": {
    marginLeft: "8px!important",
  },
};

export const AddCategoryButton = styled(IconButton)`
  && {
    background-color: transparent;
    padding: 0px;
    color: inherit;

    /* Remove ripple effect */
    & .MuiTouchRipple-root {
      display: none;
    }

    /* Disable hover background color */
    &:hover {
      background-color: transparent;
    }
  }
`;
